import React, { useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useParams } from 'react-router-dom';

import { StationData } from "../../components/stations/StationData";
import { getStationName, getRegionName } from "../../utils/helpers";
import useDatasetsMetadata from "../../components/customHooks/useDatasetsMetadata";
import useObservationData from "../../components/customHooks/useObservationData";
import useRegions from "../../components/customHooks/useRegions";
import TidalBuoyData from "../../components/stations/TidalBuoyData";
import Loading from "../../components/Loading";
import StationTabs from "../../components/stations/StationTabs";
import StationInfo from "../../components/stations/StationInfo";
import { OldData } from "./OldData";
import { OLD_DATA_THRESHOLD } from "../../utils/constants";

export const Station = () => {
  const { datasetId } = useParams();
  const [currentTab, setCurrentTab] = useState('data');
  
  const datasetsMetadata = useDatasetsMetadata();
  const observationData = useObservationData();
  const regions = useRegions();

  const station = datasetsMetadata.data?.find((dataset) => dataset?.datasetID === datasetId);
  const stationMetadata = station?.metadata;
  const stationName = getStationName(stationMetadata);
  const isTidalBuoy = station?.isTidalBuoy;
  const stationObservations = observationData.data?.find((dataset) => dataset?.datasetID === datasetId)?.obsData;

  const latestObs = stationObservations?.[stationObservations?.length-1];
  const latestObsDate = new Date(latestObs?.time);
  const now = new Date();
  const oldData = now - latestObsDate > OLD_DATA_THRESHOLD;

  return (
    <Box>
      <Flex direction={'column'} backgroundColor={'gray.50'}>
        {stationName && (
          <Box position='relative' bg="white" p={4}>
            <Text fontWeight={400} fontSize={14} opacity={'80%'} color='gray.700' textAlign='left' marginBottom={1}>
            {getRegionName(station.regionID, regions.data?.regions)}
            </Text>
            <Text fontWeight={700} fontSize={20} color='gray.700' textAlign='left'>
              {stationName}
            </Text>
          </Box>
        )}
        {oldData && (
          <Box px={4}>
            <OldData />
          </Box>
        )}
        <StationTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />
        {(datasetsMetadata.isLoading || observationData.isLoading) && <Loading />}
        {currentTab === 'data' && stationObservations?.length > 0 && (
          <>
            {!isTidalBuoy 
              && <StationData stationObservations={stationObservations} stationMetadata={stationMetadata} datasetId={datasetId} />
            }
            {isTidalBuoy
              && <TidalBuoyData stationObservations={stationObservations} stationMetadata={stationMetadata} />
            }
          </>
        )}
        {currentTab === 'info' && datasetsMetadata.isSuccess && (
          <StationInfo metadata={stationMetadata} datasetId={datasetId} />
        )}
      </Flex>
    </Box>
  );
};
